import EsusView from 'components/esus/EsusView'

export default function SindromeNeurologicaZikaMicrocefaliaView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoSindromeZikaMicro' />
}
